import {
  ADMIN_PACKAGE_CURRENT_MAIN_INDEX,
  ADD_ADMIN_PACKAGE_MAIN_ITEM,
  UPDATE_ADMIN_PACKAGE_MAIN_ITEM,
  REMOVE_ADMIN_PACKAGE_MAIN_ITEM,
  ADD_ADMIN_PACKAGE_CHILD_ITEM,
  UPDATE_ADMIN_PACKAGE_CHILD_ITEM,
  REMOVE_ADMIN_PACKAGE_CHILD_ITEM,
  CLEAR_ADMIN_PACKAGE_CART,
  ADMIN_PACKAGE_CURRENT_CHILD_INDEX,
  SET_ADMIN_PACKAGE_CART,
  SET_CUSTOMER_PACKAGE_CART,
  UPDATE_CUSTOMER_PACKAGE_CHILD_SELECT_ITEM,
  SET_CUSTOMER_DISCOUNT_PERCENTAGE,
  PLAN_SHUFFLE_UPDATE_URL,
  MAKE_PACKAGE_BUILD_URL,
  ZONE_LIST_ACCOMMODATION_DATA_MASTER,
  SET_PACKAGE_BASIC_DETAILS,
} from "../constants";
import {
  calculateCustomerPackageBeforeDiscountAmount,
  calculateDiscountedAmount,
} from "../../Component/AdminPackageDetails/PackageShowcase/commonFunction";

const initialState = {
  adminPackages: [],
  mainIndex: null,
  childIndex: null,
  customerPackage: [],
  customerPackageBeforeDiscountAmount: 0,
  customerPackageDiscountPercentage: 0,
  customerPackageAfterDiscountAmount: 0,
  makePackageBuildUrl: null,
  planShuffleUpdateUrl: null,
  zoneListAccommodationDataMaster: [],
  packageBasicDetails: null,
};

const setCustomerPackageByAdminPackage = (packageData) =>
  packageData.map((packageItem) => ({
    ...packageItem,
    child: packageItem.child
      .filter((x) => !x.not_available)
      .map((child, childIndex) => ({
        ...child,
        selected: childIndex === 0,
      })),
  }));

const recalculateCustomerPackage = (adminPackages, discountPercentage) => {
  const updatedCustomerPackage = setCustomerPackageByAdminPackage(
    adminPackages
  );
  const beforeDiscountAmount = calculateCustomerPackageBeforeDiscountAmount(
    updatedCustomerPackage
  );
  const afterDiscountAmount = calculateDiscountedAmount(
    beforeDiscountAmount,
    discountPercentage
  );

  return {
    customerPackage: updatedCustomerPackage,
    customerPackageBeforeDiscountAmount: beforeDiscountAmount,
    customerPackageAfterDiscountAmount: afterDiscountAmount,
  };
};

const clearAdminPackageCartData = {
  adminPackages: initialState.adminPackages,
  mainIndex: initialState.mainIndex,
  childIndex: initialState.childIndex,
  customerPackage: initialState.customerPackage,
  customerPackageBeforeDiscountAmount:
    initialState.customerPackageBeforeDiscountAmount,
  customerPackageDiscountPercentage:
    initialState.customerPackageDiscountPercentage,
  customerPackageAfterDiscountAmount:
    initialState.customerPackageAfterDiscountAmount,
  packageBasicDetails: initialState.packageBasicDetails,
};

const adminPackageCart = (state = initialState, action) => {
  let updatedAdminPackage;

  switch (action.type) {
    case ADMIN_PACKAGE_CURRENT_MAIN_INDEX:
      return {
        ...state,
        mainIndex: action.payload,
      };

    case ADMIN_PACKAGE_CURRENT_CHILD_INDEX:
      return {
        ...state,
        childIndex: action.payload,
      };

    case ADD_ADMIN_PACKAGE_MAIN_ITEM:
      updatedAdminPackage = [
        ...state.adminPackages,
        {
          child: [action.payload.item],
          itinerary_type: action.payload.itinerary_type,
        },
      ];

      return {
        ...state,
        adminPackages: updatedAdminPackage,
        ...recalculateCustomerPackage(
          updatedAdminPackage,
          state.customerPackageDiscountPercentage
        ),
      };

    case UPDATE_ADMIN_PACKAGE_MAIN_ITEM:
      updatedAdminPackage = state.adminPackages.map((item, idx) =>
        idx === action.payload.index ? action.payload.item : item
      );

      return {
        ...state,
        adminPackages: updatedAdminPackage,
        ...recalculateCustomerPackage(
          updatedAdminPackage,
          state.customerPackageDiscountPercentage
        ),
      };

    case REMOVE_ADMIN_PACKAGE_MAIN_ITEM:
      updatedAdminPackage = state.adminPackages.filter(
        (_, idx) => idx !== action.payload
      );

      return {
        ...state,
        adminPackages: updatedAdminPackage,
        ...recalculateCustomerPackage(
          updatedAdminPackage,
          state.customerPackageDiscountPercentage
        ),
      };

    case ADD_ADMIN_PACKAGE_CHILD_ITEM:
      updatedAdminPackage = state.adminPackages.map((packageItem, index) =>
        index === action.payload.mainIndex
          ? {
              ...packageItem,
              child: [...packageItem.child, action.payload.childItem],
            }
          : packageItem
      );

      return {
        ...state,
        adminPackages: updatedAdminPackage,
        ...recalculateCustomerPackage(
          updatedAdminPackage,
          state.customerPackageDiscountPercentage
        ),
      };

    case UPDATE_ADMIN_PACKAGE_CHILD_ITEM:
      updatedAdminPackage = state.adminPackages.map((packageItem, index) =>
        index === action.payload.mainIndex
          ? {
              ...packageItem,
              child: packageItem.child.map((child, childIdx) =>
                childIdx === action.payload.childIndex
                  ? action.payload.childItem
                  : child
              ),
            }
          : packageItem
      );

      return {
        ...state,
        adminPackages: updatedAdminPackage,
        ...recalculateCustomerPackage(
          updatedAdminPackage,
          state.customerPackageDiscountPercentage
        ),
      };

    case REMOVE_ADMIN_PACKAGE_CHILD_ITEM:
      updatedAdminPackage = state.adminPackages
        .map((packageItem, index) =>
          index === action.payload.mainIndex
            ? {
                ...packageItem,
                child: packageItem.child.filter(
                  (_, childIdx) => childIdx !== action.payload.childIndex
                ),
              }
            : packageItem
        )
        .filter((packageItem) => packageItem.child.length > 0);

      return {
        ...state,
        adminPackages: updatedAdminPackage,
        ...recalculateCustomerPackage(
          updatedAdminPackage,
          state.customerPackageDiscountPercentage
        ),
      };

    case CLEAR_ADMIN_PACKAGE_CART:
      return {
        ...state,
        ...clearAdminPackageCartData,
      };

    case SET_ADMIN_PACKAGE_CART:
      updatedAdminPackage = action.payload;

      return {
        ...state,
        adminPackages: updatedAdminPackage,
        ...recalculateCustomerPackage(
          updatedAdminPackage,
          state.customerPackageDiscountPercentage
        ),
      };

    case SET_CUSTOMER_PACKAGE_CART:
      return {
        ...state,
        ...recalculateCustomerPackage(
          state.adminPackages,
          state.customerPackageDiscountPercentage
        ),
      };

    case UPDATE_CUSTOMER_PACKAGE_CHILD_SELECT_ITEM:
      const updatedPackage = state.customerPackage.map(
        (packageItem, index) => ({
          ...packageItem,
          child:
            index === action.payload.mainIndex
              ? packageItem.child.map((child, childIndex) => ({
                  ...child,
                  selected: childIndex === action.payload.newChildIndex,
                }))
              : packageItem.child,
        })
      );
      const beforeDiscountAmount = calculateCustomerPackageBeforeDiscountAmount(
        updatedPackage
      );
      const afterDiscountAmount = calculateDiscountedAmount(
        beforeDiscountAmount,
        state.customerPackageDiscountPercentage
      );

      return {
        ...state,
        customerPackage: updatedPackage,
        customerPackageBeforeDiscountAmount: beforeDiscountAmount,
        customerPackageAfterDiscountAmount: afterDiscountAmount,
      };

    case SET_CUSTOMER_DISCOUNT_PERCENTAGE:
      const discount =
        action.payload || initialState.customerPackageDiscountPercentage;

      return {
        ...state,
        customerPackageDiscountPercentage: discount,
        ...recalculateCustomerPackage(state.adminPackages, discount),
      };

    case MAKE_PACKAGE_BUILD_URL:
      return {
        ...state,
        makePackageBuildUrl: action.payload,
      };

    case PLAN_SHUFFLE_UPDATE_URL:
      return {
        ...state,
        planShuffleUpdateUrl: action.payload,
      };

    case ZONE_LIST_ACCOMMODATION_DATA_MASTER:
      return {
        ...state,
        zoneListAccommodationDataMaster: action.payload,
      };

    case SET_PACKAGE_BASIC_DETAILS:
      return {
        ...state,
        packageBasicDetails: action.payload,
      };

    default:
      return state;
  }
};

export default adminPackageCart;
